import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";

import LocaleControls from "./LocaleControls";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CloseIcon from "@material-ui/icons/Close";
import { useTheme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  languageDialogueRoot: {
    paddingTop: "constant(safe-area-inset-top)",
    paddingTop: "env(safe-area-inset-top)",
  },
  languageDialogueMain: {
    padding: "0px 12px 0px 12px !important",
  },
  languageClose: {
    textAlign: "right",
    padding: "10px 10px 0 10px",
  },
  languageDialogueTitle: {
    textAlign: "center",
    padding: "0px 24px 15px 24px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
    },
  },
  languageContentRoot: {
    marginBottom: "25px",
  },
  cursor: {
    cursor: "pointer",
  },
}));

function Dialogue(props) {
  const { show, close, onLanguageChange } = props;
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={show}
        onClose={close}
        aria-labelledby="responsive-dialog-title"
        className={classes.languageDialogueRoot}
      >
        <div className={classes.languageClose}>
          <CloseIcon onClick={close} className={classes.cursor} />
        </div>
        <div className={classes.languageDialogueMain}>
          <DialogTitle classes={{ root: classes.languageDialogueTitle }}>
            <FormattedMessage id="app.selectYourLanguage" />
          </DialogTitle>
          <DialogContent>
            <DialogContentText classes={{ root: classes.languageContentRoot }}>
              <LocaleControls onLanguageChange={onLanguageChange} />
            </DialogContentText>
          </DialogContent>
        </div>
      </Dialog>
    </div>
  );
}

Dialogue.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.bool,
  onLanguageChange: PropTypes.func,
};

export default Dialogue;
